module.exports = __webpack_public_path__ + "static/blog76-caf3d3d90b4c20ceec1d637d9d6652a3.png";